import supabaseClient from '@/api/supabaseClient.ts';
import { useQuery } from '@tanstack/react-query';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

export type Document = {
  id: string;
  user_id: string;
  document_type: string;
  file_url: string;
  file_name: string;
  status: 'pending' | 'verified' | 'rejected';
  created_at: string;
  updated_at: string;
  signed_url?: string;
};

const useDocuments = () => {
  const queryFn = async (): Promise<Document[]> => {
    const { data, error } = await supabaseClient.functions.invoke('get_documents', {
      method: 'POST',
    });

    if (error) {
      if (error instanceof FunctionsHttpError) {
        const err: BackendErrorResponse = await error.context.json();
        throw new Error(err.errors.join(', '));
      }
      throw new Error((error as Error).message);
    }

    return data?.data?.documents || [];
  };

  return useQuery<Document[], Error>({
    queryKey: ['documents'],
    queryFn,
  });
};

export default useDocuments;
